import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { add, update, getfloorData } from "../store/actions/floorActions";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";

export default function EditModal(props) {
  const [open, setOpen] = useState(props.Open || false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const closeDialog = () => {
    setOpen(false);
    if (props.onClose) {
      props.onClose();
    }
  };

  useEffect(() => {
    setOpen(props.Open);
  }, [props.Open]);

  const statusOptions = [
    { value: "Available", label: "Available" },
    { value: "Sold", label: "Sold" },
  ];

  return (
    <Dialog open={open} onClose={closeDialog} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          {props.label === "Add Unit" ? (
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start sm:justify-center">
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-center">
                    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
                      <div className="pt-4 pb-3 bg-[#F0EDE8] px-6.5 dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                          {props.label}
                        </h3>
                      </div>
                      <form
                        onSubmit={handleSubmit((data) => {
                          const {
                            floorNum,
                            unitNum,
                            SQFT,
                            terraceSQFT,
                            Status,
                          } = data;

                          dispatch(
                            add({
                              floorNum,
                              unitNum,
                              SQFT,
                              terraceSQFT,
                              Status,
                            })
                          )
                            .then(() => {
                              dispatch(getfloorData(floorNum));
                              closeDialog();
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        })}
                      >
                        <div className="p-6.5">
                          <div className="mb-4.5">
                            <label className="mb-1 mt-3 block text-black dark:text-white">
                              Floor Number
                            </label>
                            <input
                              type="text"
                              placeholder="Floor Number"
                              className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("floorNum", { required: true })}
                            />
                            {errors.floorNum && (
                              <p>Floor Number is required.</p>
                            )}
                          </div>
                          <div className="mb-4.5">
                            <label className="mb-1 mt-3 block text-black dark:text-white">
                              Unit Number
                            </label>
                            <input
                              type="text"
                              placeholder="Unit Number"
                              className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("unitNum", { required: true })}
                            />
                            {errors.unitNum && <p>Unit Number is required.</p>}
                          </div>

                          <div className="mb-4.5">
                            <label className="mb-1 mt-3 block text-black dark:text-white">
                              Gross SQFT
                            </label>
                            <input
                              type="text"
                              placeholder="Gross SQFT"
                              className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("SQFT", { required: true })}
                            />
                            {errors.SQFT && <p>Gross SQFT is required.</p>}
                          </div>

                          <div className="mb-4.5">
                            <label className="mb-1 mt-3 block text-black dark:text-white">
                              Terrace SQFT
                            </label>
                            <input
                              type="text"
                              placeholder="Terrace SQFT"
                              className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("terraceSQFT")}
                            />
                          </div>

                          <div className="mb-5.5">
                            <label className="mb-1 mt-3 block text-black dark:text-white">
                              Status
                            </label>
                            <select
                              className="w-full mb-7 rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("Status", { required: true })}
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select Status
                              </option>
                              {statusOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            {errors.Status && <p>Status is required.</p>}
                          </div>
                          <button
                            type="submit"
                            className="flex w-full justify-center rounded bg-primary p-3 font-medium text-white hover:bg-opacity-90"
                          >
                            {props.label}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setOpen(false)}
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Cancel
                </button>
              </div>
            </DialogPanel>
          ) : (
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start sm:justify-center">
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-center">
                    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
                      <div className="pt-3 pb-2 bg-[#F0EDE8] px-6.5 dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                          {props.label}
                        </h3>
                      </div>
                      <form
                        onSubmit={handleSubmit((data) => {
                          const { SQFT, terraceSQFT, Status } = data;
                          const floorNum = props.floorNumber;
                          const unitNum = props.unitNumber;

                          dispatch(
                            update({
                              floorNum,
                              unitNum,
                              SQFT,
                              terraceSQFT,
                              Status,
                            })
                          )
                            .then(() => {
                              console.log("updated successfully");
                              dispatch(getfloorData(floorNum));
                              closeDialog();
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        })}
                      >
                        <div className="p-6.5">
                          <div className="mb-4.5">
                            <label className="mb-1 mt-3 block text-black dark:text-white">
                              Gross SQFT
                            </label>
                            <input
                              type="text"
                              placeholder="Gross SQFT"
                              className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("SQFT", { required: true })}
                            />
                            {errors.SQFT && <p>Gross SQFT is required.</p>}
                          </div>

                          <div className="mb-4.5">
                            <label className="mb-1 mt-3 block text-black dark:text-white">
                              Terrace SQFT
                            </label>
                            <input
                              type="text"
                              placeholder="Terrace SQFT"
                              className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("terraceSQFT")}
                            />
                          </div>

                          <div className="mb-5.5">
                            <label className="mb-1 mt-3 block text-black dark:text-white">
                              Status
                            </label>
                            <select
                              className="w-full mb-7 rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                              {...register("Status", { required: true })}
                              defaultValue=""
                            >
                              <option value="" disabled>
                                Select Status
                              </option>
                              {statusOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            {errors.Status && <p>Status is required.</p>}
                          </div>
                          <button
                            type="submit"
                            className="flex w-full justify-center rounded bg-primary p-3 font-medium text-white hover:bg-opacity-90"
                          >
                            {props.label}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setOpen(false)}
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                >
                  Cancel
                </button>
              </div>
            </DialogPanel>
          )}
        </div>
      </div>
    </Dialog>
  );
}
